function authenticate_payment(client_secret, obj) {
  stripe.confirmCardPayment(client_secret).then(function(result) {
    console.log("authenticate payment result", result)
    if (result.error) {
      if (window.toastr) {
        window.toastr.error(result.error.message, "Authentication Error", { timeOut: 0 });
      } else {
        alert(result.error.message);
      }
    } else {
      if (window.toastr) {
        window.toastr.success(window.I18n.t("payment_method.create.success_past_due"));
      } else {
        alert(window.I18n.t("payment_method.create.success_past_due"));
      }
    }
  });
}

function setSubmitLoading(btn, isLoading) {
  if (!btn) return;
  if (isLoading) {
    btn.setAttribute('disabled', 'disabled');
    if (!btn.querySelector('.spinner-border-sm')) {
      const spinner = document.createElement('span');
      spinner.className = 'spinner-border spinner-border-sm inline-block mr-2 animate-spin rounded-full border-2 border-current border-t-transparent w-4 h-4';
      spinner.style.verticalAlign = 'middle';
      spinner.style.marginRight = '8px';
      btn.prepend(spinner);
    }
  } else {
    btn.removeAttribute('disabled');
    const spinner = btn.querySelector('.spinner-border-sm');
    if (spinner) spinner.remove();
  }
}

function mountStripeElements() {
  const cardNumEl = document.getElementById("card_number");
  if (!cardNumEl) {
    return;
  }

  // Ensure Stripe is correctly initialized on page transitions (highly robust against Turbo page changes)
  const stripeKey = document.body.getAttribute('data-stripe-publishable-key');
  if (stripeKey && window.Stripe) {
    window.stripe = window.Stripe(stripeKey);
  }

  if (!window.stripe) {
    console.error("Stripe is not initialized or window.stripe is undefined.");
    return;
  }

  // Clean up any previously mounted Stripe Elements to prevent duplicate mount errors on Turbo transitions
  if (window.stripeCardNumber) {
    try { window.stripeCardNumber.destroy(); } catch (e) { console.log(e); }
  }
  if (window.stripeCardExpiry) {
    try { window.stripeCardExpiry.destroy(); } catch (e) { console.log(e); }
  }
  if (window.stripeCardCvc) {
    try { window.stripeCardCvc.destroy(); } catch (e) { console.log(e); }
  }

  /***** Transform card into Stripe object */
  var style = {
    base: {
      color: '#fafafa',
      fontFamily: 'Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
      fontSize: '15px',
      '::placeholder': {
        color: '#71717a'
      }
    },
    invalid: {
      color: '#ef4444'
    }
  }

  var elements = stripe.elements();
  var cardNumber = elements.create('cardNumber', { style: style });
  var cardExpiry = elements.create('cardExpiry', { style: style });
  var cardCvc = elements.create('cardCvc', { style: style });

  // Store element instances globally so they can be cleaned up on the next page transition
  window.stripeCardNumber = cardNumber;
  window.stripeCardExpiry = cardExpiry;
  window.stripeCardCvc = cardCvc;

  cardNumber.mount("#card_number")
  cardExpiry.mount("#card_expiry")
  cardCvc.mount("#card_cvc")

  /* Credit Card identification */
  cardNumber.on("change", (ev) => {
    document.querySelectorAll('.brand').forEach(el => el.style.display = 'none');
    if (ev.brand) {
      const brandEl = document.querySelector('.' + ev.brand);
      if (brandEl) {
        brandEl.style.display = 'block';
      }
    }
  });

  const form = document.getElementById('payment-form');
  if (form) {
    form.addEventListener('submit', function(ev) {
      ev.preventDefault();

      var submit = document.getElementById('stripe-submit');
      if (submit) {
        setSubmitLoading(submit, true);
      }

      stripe.createPaymentMethod({
        type: 'card',
        card: cardNumber
      }).then(stripePaymentMethodHandler);
    });
  }

  function stripePaymentMethodHandler(result) {
    var submit = document.getElementById('stripe-submit');

    if (result.error) {
      if (window.toastr) {
        window.toastr.error(result.error.message, "Payment Error", { timeOut: 0 });
      } else {
        alert(result.error.message);
      }
      if (submit) {
        setSubmitLoading(submit, false);
      }
    } else {
      const userIdEl = document.getElementById("user_id");
      const userId = userIdEl ? userIdEl.value : "";
      
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

      fetch(`/${window.I18n.locale}/payment_method/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          user_id: userId,
          pm_id: result.paymentMethod.id
        })
      })
      .then(res => res.json())
      .then((data) => {
        if (data && typeof data.payment_intent !== 'undefined') {
          const { client_secret, status } = data.payment_intent;

          if (status === 'requires_action') {
            stripe.confirmCardPayment(client_secret).then(function(result) {
              console.log(result);
              if (result.error) {
                if (window.toastr) {
                  window.toastr.error(result.error.message, "Authentication Error", { timeOut: 0 });
                } else {
                  alert(result.error.message);
                }
                if (submit) {
                  setSubmitLoading(submit, false);
                }
              }
            });
          }
        } else {
          if (submit) {
            setSubmitLoading(submit, false);
          }
        }
      })
      .catch((err) => {
        console.error('Error saving payment method:', err);
        if (submit) {
          setSubmitLoading(submit, false);
        }
      });
    }
  }
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector("body.users-edit")) {
    mountStripeElements();
    console.log('mountStripeElements')

    document.querySelectorAll('.authenticate-payment').forEach(el => {
      el.addEventListener('click', (e) => {
        const href = e.target.getAttribute('href');
        if (href && href.endsWith("#cards")) {
          return true;
        } else {
          e.target.setAttribute('href', '#cards');
        }
        
        var client_secret = e.target.getAttribute('data-client-secret');
        authenticate_payment(client_secret, e.target);
        e.preventDefault();
      });
    });
  }
});

document.addEventListener('stripe:reload', function(evt) {
  if (document.querySelector("body.users-edit")) {
    console.log("card-form.js reload");
    mountStripeElements();
  }
});
